var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pss__layout"},[_c('pss-head'),_c('pss-main',[_vm._t("default")],2),_c('pss-foot'),_c('pss-process')],1)}
var staticRenderFns = []

export { render, staticRenderFns }